import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useCustomerAuth } from '../../contexts/CustomerAuthContext';
import './CustomerAuth.css';

const CustomerAuth = () => {
  console.log('🟢 CustomerAuth: Component rendering');
  console.log('🟢 CustomerAuth: Current URL:', window.location.href);

  const { login, register, isAuthenticated } = useCustomerAuth();
  const [isLogin, setIsLogin] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  console.log('🟢 CustomerAuth: location.search:', location.search);

  // Get store slug and redirect URL from URL params or location state
  const storeSlug = new URLSearchParams(location.search).get('store') ||
                   location.state?.storeSlug || '';
  const redirectUrl = new URLSearchParams(location.search).get('redirect') ||
                     location.state?.redirect || '/customer/dashboard';
  const prefillEmail = new URLSearchParams(location.search).get('email') || '';

  console.log('🟢 CustomerAuth: redirectUrl:', redirectUrl);
  console.log('🟢 CustomerAuth: storeSlug:', storeSlug);
  
  // Check if there's a preserved cart from checkout redirect
  const [hasPreservedCart, setHasPreservedCart] = useState(false);
  
  useEffect(() => {
    const preservedCart = localStorage.getItem('checkout_redirect_cart');
    if (preservedCart) {
      setHasPreservedCart(true);
    }
  }, []);

  // Pre-fill email from URL parameter
  useEffect(() => {
    if (prefillEmail) {
      setFormData(prev => ({ ...prev, email: prefillEmail }));
    }
  }, [prefillEmail]);

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user starts typing
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      if (isLogin) {
        await handleLogin();
      } else {
        await handleRegister();
      }
    } catch (err) {
      setError(err.message || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = async () => {
    const { email, password } = formData;

    if (!email || !password) {
      throw new Error('Email and password are required');
    }

    const result = await login(email, password, storeSlug);

    if (result.success) {
      setSuccess('Login successful! Redirecting...');
      
      // Restore preserved cart if it exists
      const preservedCart = localStorage.getItem('checkout_redirect_cart');
      if (preservedCart) {
        try {
          const cartData = JSON.parse(preservedCart);
          // Don't store cart data in localStorage for security
          localStorage.removeItem('checkout_redirect_cart');
          console.log('Restored preserved cart:', cartData);
        } catch (error) {
          console.error('Error restoring preserved cart:', error);
        }
      }
      
      // Redirect to the specified URL or default to dashboard
      setTimeout(() => {
        // Re-extract redirectUrl here to ensure it's the latest value
        const currentUrlParams = new URLSearchParams(window.location.search);
        const currentRedirectUrl = currentUrlParams.get('redirect') || '/customer/dashboard';
        const currentStoreSlug = currentUrlParams.get('store') || 'kwika-digits';

        console.log('CustomerAuth: Inside setTimeout - currentRedirectUrl:', currentRedirectUrl);
        console.log('CustomerAuth: Inside setTimeout - currentRedirectUrl.startsWith("http"):', currentRedirectUrl.startsWith('http'));
        console.log('CustomerAuth: Inside setTimeout - currentRedirectUrl.startsWith("/checkout"):', currentRedirectUrl.startsWith('/checkout'));
        console.log('CustomerAuth: Inside setTimeout - currentRedirectUrl.includes("checkout"):', currentRedirectUrl.includes('checkout'));

        // Force checkout redirects to main frontend
        if (currentRedirectUrl.includes('checkout') || currentRedirectUrl.startsWith('/checkout')) {
          const frontendUrl = `${window.location.origin}${currentRedirectUrl}`;
          console.log('CustomerAuth: FORCING checkout redirect to main frontend:', frontendUrl);
          window.location.href = frontendUrl;
        } else if (currentRedirectUrl.startsWith('http')) {
          // External URL, redirect directly
          console.log('CustomerAuth: External URL redirect to:', currentRedirectUrl);
          window.location.href = currentRedirectUrl;
        } else {
          // Internal route, use navigate
          console.log('CustomerAuth: Internal route redirect to:', currentRedirectUrl);
          navigate(currentRedirectUrl, { state: { storeSlug: currentStoreSlug } });
        }
      }, 1500);
    } else {
      throw new Error(result.error || 'Login failed');
    }
  };

  const handleRegister = async () => {
    const { firstName, lastName, email, phone, password, confirmPassword } = formData;

    if (!firstName || !lastName || !email || !phone || !password) {
      throw new Error('All fields are required');
    }

    if (password !== confirmPassword) {
      throw new Error('Passwords do not match');
    }

    if (password.length < 8) {
      throw new Error('Password must be at least 8 characters long');
    }

    const result = await register({
      firstName,
      lastName,
      email,
      phone,
      password
    }, storeSlug);

    if (result.success) {
      setSuccess('Registration successful! Please check your email to verify your account.');
      
      // Restore preserved cart if it exists
      const preservedCart = localStorage.getItem('checkout_redirect_cart');
      if (preservedCart) {
        try {
          const cartData = JSON.parse(preservedCart);
          // Don't store cart data in localStorage for security
          localStorage.removeItem('checkout_redirect_cart');
          console.log('Restored preserved cart after registration:', cartData);
        } catch (error) {
          console.error('Error restoring preserved cart after registration:', error);
        }
      }
      
      // Redirect to the specified URL or default to dashboard
      setTimeout(() => {
        // Re-extract redirectUrl here to ensure it's the latest value
        const currentUrlParams = new URLSearchParams(window.location.search);
        const currentRedirectUrl = currentUrlParams.get('redirect') || '/customer/dashboard';
        const currentStoreSlug = currentUrlParams.get('store') || 'kwika-digits';

        console.log('CustomerAuth: Inside setTimeout (register) - currentRedirectUrl:', currentRedirectUrl);
        console.log('CustomerAuth: Inside setTimeout (register) - currentRedirectUrl.startsWith("http"):', currentRedirectUrl.startsWith('http'));
        console.log('CustomerAuth: Inside setTimeout (register) - currentRedirectUrl.startsWith("/checkout"):', currentRedirectUrl.startsWith('/checkout'));
        console.log('CustomerAuth: Inside setTimeout (register) - currentRedirectUrl.includes("checkout"):', currentRedirectUrl.includes('checkout'));

        // Force checkout redirects to main frontend
        if (currentRedirectUrl.includes('checkout') || currentRedirectUrl.startsWith('/checkout')) {
          const frontendUrl = `${window.location.origin}${currentRedirectUrl}`;
          console.log('CustomerAuth: FORCING checkout redirect (register) to main frontend:', frontendUrl);
          window.location.href = frontendUrl;
        } else if (currentRedirectUrl.startsWith('http')) {
          // External URL, redirect directly
          console.log('CustomerAuth: External URL redirect (register) to:', currentRedirectUrl);
          window.location.href = currentRedirectUrl;
        } else {
          // Internal route, use navigate
          console.log('CustomerAuth: Internal route redirect (register) to:', currentRedirectUrl);
          navigate(currentRedirectUrl, { state: { storeSlug: currentStoreSlug } });
        }
      }, 2000);
    } else {
      throw new Error(result.error || 'Registration failed');
    }
  };

  const handleForgotPassword = async () => {
    const { email } = formData;

    if (!email) {
      setError('Please enter your email address');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL || '/api'}/customer/auth/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email })
      });

      const data = await response.json();

      if (response.ok) {
        setSuccess('Password reset link sent to your email');
      } else {
        throw new Error(data.error || 'Failed to send reset link');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="customer-auth">
      <div className="auth-container">
        <div className="auth-header">
          <h1>{isLogin ? 'Welcome Back' : 'Create Account'}</h1>
          <p>
            {isLogin 
              ? 'Sign in to your account to continue' 
              : 'Create an account to manage your orders and preferences'
            }
          </p>
          {hasPreservedCart && (
            <div style={{
              backgroundColor: '#f0f9ff',
              border: '1px solid #0ea5e9',
              borderRadius: '8px',
              padding: '12px',
              marginTop: '16px',
              fontSize: '14px',
              color: '#0c4a6e'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span>🛒</span>
                <span><strong>Your cart items have been preserved!</strong> Complete your login to continue with checkout.</span>
              </div>
            </div>
          )}
        </div>

        <div className="auth-tabs">
          <button 
            className={`tab ${isLogin ? 'active' : ''}`}
            onClick={() => setIsLogin(true)}
          >
            Login
          </button>
          <button 
            className={`tab ${!isLogin ? 'active' : ''}`}
            onClick={() => setIsLogin(false)}
          >
            Register
          </button>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          {!isLogin && (
            <>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="firstName">First Name</label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    required={!isLogin}
                    placeholder="Enter your first name"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="lastName">Last Name</label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    required={!isLogin}
                    placeholder="Enter your last name"
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="phone">Phone Number</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  required={!isLogin}
                  placeholder="Enter your phone number"
                />
              </div>
            </>
          )}

          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              required
              placeholder="Enter your email address"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              required
              placeholder="Enter your password"
              minLength={8}
            />
          </div>

          {!isLogin && (
            <div className="form-group">
              <label htmlFor="confirmPassword">Confirm Password</label>
              <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleInputChange}
                required={!isLogin}
                placeholder="Confirm your password"
                minLength={8}
              />
            </div>
          )}

          {isLogin && (
            <div className="form-options">
              <button
                type="button"
                onClick={handleForgotPassword}
                className="forgot-password"
                disabled={loading}
              >
                Forgot Password?
              </button>
            </div>
          )}

          {error && (
            <div className="alert alert-error">
              {error}
            </div>
          )}

          {success && (
            <div className="alert alert-success">
              {success}
            </div>
          )}

          <button
            type="submit"
            className="btn-primary"
            disabled={loading}
          >
            {loading ? (
              <div className="loading-spinner">
                <div className="spinner"></div>
                {isLogin ? 'Signing in...' : 'Creating account...'}
              </div>
            ) : (
              isLogin ? 'Sign In' : 'Create Account'
            )}
          </button>
        </form>

        <div className="auth-footer">
          <p>
            {isLogin ? "Don't have an account? " : "Already have an account? "}
            <button
              type="button"
              onClick={() => setIsLogin(!isLogin)}
              className="link-button"
            >
              {isLogin ? 'Create one' : 'Sign in'}
            </button>
          </p>
        </div>

        {storeSlug && (
          <div className="store-info">
            <p>You're signing in for: <strong>{storeSlug}</strong></p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomerAuth;
